import { useMemo, useRef,useState } from 'react'
import { useForm } from 'react-hook-form'

import { PktButton,PktMessagebox, PktTextinput } from '..'

type FormData = {
  firstValue: string
  secondValue: string
  dateValue: string
  numberValue: number | string
}

export default function Textinput() {
  const [aValue, setAValue] = useState('')

  const [buttonValue, setButtonValue] = useState('🎉')
  const [buttonClickCount, setButtonClickCount] = useState(0)

  const { handleSubmit, register, getValues } = useForm<FormData>({
    defaultValues: {
      firstValue: 'First value',
      secondValue: 'Second value',
      dateValue: '2024-10-11',
      numberValue: '5',
    },
  })

  const MOCK_SUBMIT = useMemo(() => {
    return () => {
      const values = getValues()
      alert('Submitting ' + JSON.stringify(values))
    }
  }, [getValues])

  const textinputRef = useRef<HTMLInputElement>(null)
  return (
    <>
      <main className="page-main pkt-container">
        <h1>Textinput</h1>

        <section className="component">
          <PktTextinput
            id="testinput1"
            value={aValue}
            label={'Textinput (Klikket: ' + buttonClickCount + ' ganger)'}
            placeholder="Placeholder"
            onChange={(e) => {
              console.log('onChange', e.target)
              setAValue(e.target.value)
            }}
            helptext={
              <>
                <PktButton
                  size="small"
                  skin="secondary"
                  onClick={(e) => {
                    setButtonValue('🥳')
                    setButtonClickCount(buttonClickCount + 1)
                  }}
                >
                  {buttonValue}
                </PktButton>
                &nbsp;Dette er tekstfelt med en knapp som kan klikkes på for å endre tekst
              </>
            }
            ref={textinputRef}
            data-testid="test-name"
          />
          <PktMessagebox>En verdi: {aValue}</PktMessagebox>
          <PktButton onClick={() => setAValue('')}>Reset</PktButton>
          <br />
          <PktTextinput id="testinputdate" label="Dateinput" type="date" dataTestid="test-date" skipForwardTestid />
          <PktTextinput
            id="testinputcounter"
            label="Textinput med counter"
            placeholder="Placeholder"
            counter
            counterMaxLength={35}
          />
          <PktTextinput id="testinput1fullwidth" label="Textinput full bredde" placeholder="Placeholder" fullwidth />
          <PktTextinput
            id="testinput2"
            label="Tekstinput inline"
            helptext="Dette er tekst over tekstfeltet"
            inline
          ></PktTextinput>
          <PktTextinput
            id="testinput22"
            label="Tekstinput inline"
            helptext="Dette er tekst over tekstfeltet"
            inline
          ></PktTextinput>
          <PktTextinput
            id="testinput3"
            label="Tekstinput med tag"
            helptext="Dette er tekst over tekstfeltet"
            requiredTag
          ></PktTextinput>
          <PktTextinput
            id="testinput4"
            label="Tekstinput med tag"
            helptext="Dette er tekst over tekstfeltet"
            optionalTag
          ></PktTextinput>
          <PktTextinput
            id="testinput4"
            label="Tekstinput med alle tags"
            helptext="Dette er tekst over tekstfeltet"
            optionalTag
            requiredTag
            tagText="Tag"
          ></PktTextinput>
          <PktTextinput
            id="testinput5"
            label="Tekstinput med prefix"
            helptext="Dette er tekst over tekstfeltet"
            prefix="+47"
          ></PktTextinput>
          <PktTextinput
            id="testinput6"
            label="Tekstinput med suffix"
            helptext="Dette er tekst over tekstfeltet"
            suffix="kr"
          ></PktTextinput>
          <PktTextinput
            id="testinput7"
            label="Tekstinput med suffix og ikon"
            helptext={'Dette er tekst over tekstfeltet'}
            suffix="Suffix"
            iconNameRight="close"
          ></PktTextinput>
          <PktTextinput
            id="testinput72"
            label="Tekstinput med prefix, suffix og ikon"
            helptext="Dette er tekst over tekstfeltet"
            prefix="Prefix"
            suffix="Suffix"
            iconNameRight="close"
          ></PktTextinput>
          <PktTextinput
            id="testinput8"
            label="Tekstinput med ikon"
            helptext="Dette er tekst over tekstfeltet"
            iconNameRight="close"
          ></PktTextinput>
          <PktTextinput
            id="testinput82"
            label="Tekstinput med søk"
            helptext="Her kan du søke etter meningen med livet."
            placeholder="Søk…"
            type="search"
          ></PktTextinput>
          <PktTextinput
            id="testinput9"
            label="Tekstinput med error"
            helptext="Dette er tekst over tekstfeltet"
            iconNameRight="close"
            errorMessage={<a href="#">Dette er en feilmelding i React</a>}
            hasError
          ></PktTextinput>
          <PktTextinput
            id="testinput10"
            label="Tekstinput med dropdown"
            helptext={
              <>
                Bruk dette <a href="#">tekstfeltet</a> til å skrive en kort varsling.
              </>
            }
            iconNameRight="close"
            helptextDropdown={
              <>
                Dette er <a href="#">teksten</a> i dropdown
              </>
            }
          ></PktTextinput>
          <PktTextinput
            id="testinput11"
            label="Tekstinput disabled"
            helptext="Bruk dette tekstfeltet til å skrive en kort varsling."
            iconNameRight="close"
            helptextDropdown="Dette er teksten i dropdown"
            disabled
          ></PktTextinput>
        </section>
        <section className="component">
          <h2>Test av reell skjemaintegrasjon</h2>
          <form onSubmit={handleSubmit(MOCK_SUBMIT)}>
            <PktTextinput id="firstValue" label="Første verdi" {...register('firstValue')} />
            <br />
            <PktTextinput id="secondValue" label="Andre verdi" {...register('secondValue')} />
            <br />
            <PktTextinput id="dateValue" label="Datoverdi" {...register('dateValue')} type="date" />
            <br />
            <PktTextinput
              id="numberValue"
              label="Tallverdi"
              min="4"
              max="7"
              {...register('numberValue')}
              type="number"
            />
            <br />
            <PktButton type="submit">Submit</PktButton>
          </form>
        </section>
        <section className="component">
          <h2>Test av min og max i type="number"</h2>
          <form>
            <PktTextinput id="testinputnumber" label="Tallverdi" type="number" min={1} max={10}></PktTextinput>
            <label htmlFor="testinputnumber2">Tallverdi native</label>
            <input className="pkt-input" type="number" name="testinputnumber2" min={1} max={10} />
            <PktButton type="submit">Submit</PktButton>
          </form>
        </section>
      </main>
    </>
  )
}
